import z from 'zod';
import { TimeUnit } from '@mews/enums';

const toOptionalStringArray = (arg: string | string[] | undefined): string[] | undefined => {
    if (!arg) {
        return undefined;
    }

    if (Array.isArray(arg)) {
        return arg;
    }

    return [arg];
};

export enum TimelineFilterSchemaKeys {
    ServiceId = 'ServiceId',
    FloorNumber = 'FloorNumber',
    ResourceFeatureId = 'ResourceFeatureId',
    ResourceCategoryId = 'ResourceCategoryId',
}

export const timelineFilterSchema = z.object({
    [TimelineFilterSchemaKeys.ServiceId]: z.string(),
    [TimelineFilterSchemaKeys.FloorNumber]: z
        .array(z.string())
        .or(z.string())
        .optional()
        .transform(toOptionalStringArray),
    [TimelineFilterSchemaKeys.ResourceFeatureId]: z
        .array(z.string())
        .or(z.string())
        .optional()
        .transform(toOptionalStringArray),
    [TimelineFilterSchemaKeys.ResourceCategoryId]: z
        .array(z.string())
        .or(z.string())
        .optional()
        .transform(toOptionalStringArray),
});

export const timelineUrlFilterSchema = z.optional(timelineFilterSchema);

export type TimelineFilterValues = z.infer<typeof timelineFilterSchema>;

export interface TimelineFilterValuesExtended extends TimelineFilterValues {
    timeUnit?: TimeUnit;
    dateTime?: string;
}
